import React from "react";
import { Button, CheckboxField, DateField, MenuItem, SelectField, Stack, TextField } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { EmployeeSelect, ReadTextField } from "@icoach/components";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { displayDateText, isValidDate, parseDate } from "@util/moment";
import { convertBooleanToOptionArray, getErrorModuleStatus } from "@util/utils";
import { useMembershipQuitFormContext } from "@icoach/documents/membership/quit/MembershipQuitFormContext";

const MembershipQuitFormInfoSection104 = ({ resource, rentCabinetConfirmRef }) => {
	const { formData, formRef, validationErrors, updateField, dialogRef, isReadOnly } = useMembershipQuitFormContext();

	const handleDateFieldChange = key => (node, value) => {
		if (!isValidDate(value)) return false;
		updateField(key, value);
	};

	return (
		<>
			<FieldGroup label="表單資訊">
				<Grid item xs={4}>
					<DateField
						label="申請日期"
						ref={el => (formRef.current.applyDate = el)}
						key={parseDate(formData?.applyDate)}
						defaultValue={parseDate(formData?.applyDate)}
						onChange={handleDateFieldChange("applyDate")}
						{...getErrorModuleStatus(validationErrors, "applyDate")}
						readOnly={isReadOnly}
						fullWidth
					/>
				</Grid>
				<Grid item xs={4}>
					<ReadTextField label="會籍終止生效日">{displayDateText(formData?.quitDate)}</ReadTextField>
				</Grid>
				<Grid item xs={4}>
					<EmployeeSelect
						label="經辦教練"
						ref={el => (formRef.current.employeeID = el)}
						key={formData?.employeeID}
						defaultValue={formData?.employeeID}
						onChange={v => updateField("employeeID", v)}
						{...getErrorModuleStatus(validationErrors, "employeeID")}
						options={resource?.coachOptions || []}
						readOnly={isReadOnly}
						fullWidth
						required
					/>
				</Grid>
			</FieldGroup>
			<FieldGroup label="意見回饋">
				<Grid item xs={12}>
					<CheckboxField
						ref={el => (formRef.current.isExtendEndDate = el)}
						key={convertBooleanToOptionArray(formData?.isExtendEndDate)}
						defaultValue={convertBooleanToOptionArray(formData?.isExtendEndDate)}
						onChange={e => updateField("isExtendEndDate", e.target.checked)}
						{...getErrorModuleStatus(validationErrors, "isExtendEndDate")}
						readOnly={isReadOnly}
					>
						<CheckboxField.Checkbox label="已與會員協商可運動到月底，故調整會籍終止生效日" value={1} />
					</CheckboxField>
				</Grid>
				<Grid item xs={8}>
					<SelectField
						label="終止原因"
						ref={el => (formRef.current.reasonType = el)}
						key={formData?.reasonType}
						defaultValue={formData?.reasonType}
						onChange={(e, n, v) => updateField("reasonType", v)}
						{...getErrorModuleStatus(validationErrors, "reasonType")}
						readOnly={isReadOnly}
						displayEmpty
						fullWidth
						required
					>
						{resource?.quitReasonTypeOptions?.map(options => (
							<MenuItem key={options.value} value={options.value}>
								{options.text}
							</MenuItem>
						))}
					</SelectField>
				</Grid>
				<Grid item xs={8}>
					<TextField
						label="誠摯邀請您對於店舖服務，提供寶貴的意見"
						ref={el => (formRef.current.reasonText = el)}
						key={formData?.reasonText}
						defaultValue={formData?.reasonText}
						onChangeNative={e => updateField("reasonText", e.target.value)}
						{...getErrorModuleStatus(validationErrors, "reasonText")}
						readOnly={isReadOnly}
						multiline
						fullWidth
						rows={4}
					/>
				</Grid>
			</FieldGroup>
			{!isReadOnly && (
				<FieldGroup>
					<Grid item xs={12}>
						<Stack direction={"row"} alignItems="start">
							<CheckboxField ref={rentCabinetConfirmRef} defaultValue={isReadOnly ? [1] : undefined} readOnly={isReadOnly} required>
								<CheckboxField.Checkbox label="已辦理置物櫃退租作業" value={1} />
							</CheckboxField>
							<Button
								variant="outlined"
								onClick={() =>
									dialogRef.current?.openQuitAllRentCabinetDialog({
										memberID: formData?.memberID,
										membershipID: formData?.membershipID,
									})
								}
							>
								辦理租櫃退租
							</Button>
						</Stack>
					</Grid>
				</FieldGroup>
			)}
		</>
	);
};

export default MembershipQuitFormInfoSection104;
